// src/api/apis.js
import http from './axios'

export const api = {

  // ==================== 登录 & 用户相关 ====================
  userlogin(data) {
    return http.post('/api/login/userlogin', data)
  },
  getDanye(data) {
    return http.post('/api/login/danye', data)
  },
  getuserinfo() {
    return http.post('/api/member/userinfo')
  },
  uploadAvatar(formData) {
    return http.post('/api/Common/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  edituserinfo(data) {
    return http.post('/api/member/edituserinfo', data)
  },
  changePassword(data) {
    return http.post('/api/member/changePassword', data)
  },
  //获取所有人总的录音时长排名
  getStudyRanking(data) {
    return http.post('/api/member/getStudyRanking', data)
  },
  // ==================== 首页 & 公告 ====================
  getBanner() {
    return http.post('/api/index/banner')
  },
  tk_gonggao() {
    return http.post('/api/index/tk_gonggao')
  },
  getnotice(data) {
    return http.post('/api/index/getnotice', data)
  },
  getnoticeshow(data) {
    return http.post('/api/index/getnotice_show', data)
  },

  // ==================== 打卡相关 (Checkin控制器) ====================
  // 获取打卡情况（月历、累计、连续、当月卡补签次数）
  getcheckinData(data) {
    return http.post('/api/checkin/checkinData', data)
  },


  // 添加打卡记录（书籍/视频）
  taskdaka(data) {
    return http.post('/api/checkin/addtaskdakajl', data)
  },

  
  // 保存视频播放进度
  saveVideoProgress(data) {
    return http.post('/api/checkin/saveVideoProgress', data)
  },
  
  // 获取视频播放进度列表
  getVideoProgress(data) {
    return http.post('/api/checkin/getVideoProgress', data)
  },

  // 打卡打卡记录
  gettaskdakalist(data) {
    return http.post('/api/checkin/taskdakalist', data)
  },
  
  //获取某个书籍任务的打卡记录和心得记录
  get_task_daka_biji(data) {
    return http.post('/api/checkin/get_task_daka_biji', data)
  },
  //获取某个视频任务的打卡记录
  get_task_daka_video(data) {
    return http.post('/api/checkin/getTaskDakaList', data)
  },

  // ==================== 任务相关 (Task控制器) ====================
    // 检查指定日期是否有任务
  checkDateHasTask(data) {
    return http.post('/api/Task/checkDateHasTask', data)
  },
  // 任务列表（含打卡状态）
  gettasklist(data) {
    return http.post('/api/task/tasklist', data)
  },
    // 昨日任务完成情况
  gettask_yesterday(data) {
    return http.post('/api/task/task_yesterday', data)  
  },
  // 任务详情
  gettaskinfo(data) {
    return http.post('/api/task/taskinfo', data)
  },
  // 获取任务总列表（章节+小节）
  getchapterall(data) {
    return http.post('/api/task/chapterall', data)
  },
  // 获取章节列表（小节列表）
  getChapterList(data) {
    return http.post('/api/task/chapter', data)
  },
  // 获取章节内容详情
  getChapterContent(data) {
    return http.post('/api/task/chaptercon', data)
  },

  // ==================== 学习心得相关 (StudyNote控制器) ====================
  // 添加心得
  addNote(data) {
    return http.post('/api/studynote/addNote', data)
  },
  // 心得列表（支持搜索、日期筛选）
  study_notes(data) {
    return http.post('/api/studynote/study_notes', data)
  },
  // 心得详情
  study_notes_show(data) {
    return http.post('/api/studynote/study_notes_show', data)
  },
  // 删除心得
  study_notes_del(data) {
    return http.post('/api/studynote/study_notes_del', data)
  },
  // 修改心得
  study_notes_update(data) {
    return http.post('/api/studynote/study_notes_update', data)
  },

  // ==================== 考试相关 (Exam控制器) ====================
  // 考试列表
  getexam_list(data) {
    return http.post('/api/exam/exam_list', data)
  },
  // 考试详情
  getexam_detial(data) {
    return http.post('/api/exam/exam_detial', data)
  },
  // 获取整套考题
  getexam_show(data) {
    return http.post('/api/exam/exam_show', data)
  },
  // 记录考试开始时间
  task_stary_time(data) {
    return http.post('/api/exam/task_stary', data)
  },
  // 考试交卷
  task_submit(data) {
    return http.post('/api/exam/task_submit', data)
  },
  // 考试成绩
  task_chengji(data) {
    return http.post('/api/exam/task_chengji', data)
  },
  // 我的考试记录
  getmyexams(data) {
    return http.post('/api/exam/getmyexams', data)
  },
  // 我的考试详情
  getmyexam_show(data) {
    return http.post('/api/exam/getmyexam_show', data)
  },

}